const ReportIconHover = () => {
    return (
  <svg  className="MuiSvgIcon-root" xmlns="http://www.w3.org/2000/svg" width="16.001" height="20" viewBox="0 0 16.001 20">
    <path id="Subtraction_27" data-name="Subtraction 27" d="M13234-14600h-10a3,3,0,0,1-3-3v-14a3,3,0,0,1,3-3h5.585a2.014,2.014,0,0,1,1.416.587l5.412,5.412a2,2,0,0,1,.587,1.416v9.584A3,3,0,0,1,13234-14600Zm-8-7a1,1,0,0,0-1,1,1,1,0,0,0,1,1h6a1,1,0,0,0,1-1,1,1,0,0,0-1-1Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1h6a1,1,0,0,0,1-1,1,1,0,0,0-1-1Z" transform="translate(-13220.999 14620)" />
  </svg>
    )
  }
  export default ReportIconHover
  